import { ICongressionalRecordPDF } from './index.js'

export interface ICongressionalRecordDigest {
  Label: string
  Ordinal: number
  PDF: ICongressionalRecordPDF[]
}
